const cero = {
    name: 'CERO',
    type: 'product',
    logo: {
        image: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2Fcero.svg?alt=media&token=5de58951-4768-4c94-8d42-7ea751e0485e',
        height: '2.4em'
    },
    background: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Fcero%2Fcero-2.jpg?alt=media&token=1ef54071-bd14-4d1f-a833-43899882a002',
    heading: 'Impressive transparency dissolves the line between inside and outside. With its great attention to detail, CERO will make you believe it’s invisible.',
    blurb: 'As the leading supplier in the field of folding glass doors and glass extensions, CERO benefits from over 30 years of experience in the field of customized solutions with the guarantee of precision, and intelligent technical details.',
    text: {
        1: 'Being part of the Solarlux Brand, NME have worked on multiple Cero projects through out the years. The award winning system is simple elegant and so minimalistic yet its performance is unmatched anywhere else.',
        2: 'Cero is yet another ingenious brand produced by Solarlux. Cero is more than just a sliding window; it is a generously sized horizontally movable window with simple but very elegant design which also provides infinite visibility to the user.'
    },
    website: 'http://cero.de/en/',
    imageCount: '6',
    images: {
        1: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Fcero%2Fgallery%2F1.png?alt=media&token=87441691-b7ad-4af0-aa87-a17f8f59187e',
        2: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Fcero%2Fgallery%2F2.png?alt=media&token=6b00d9f6-9f3e-4ee1-ab37-8d90b8eb2f6b',
        3: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Fcero%2Fgallery%2F3.png?alt=media&token=fb710591-e85a-4453-aa2a-eb44743e7432',
        4: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Fcero%2Fgallery%2F4.png?alt=media&token=fdc093e7-ba0e-4e8d-aa15-04a40728b09e',
        5: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Fcero%2Fgallery%2F5.png?alt=media&token=0bf2f311-bd4c-4c23-9e3a-e589db13ac7e',
        6: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Fcero%2Fgallery%2F6.png?alt=media&token=4642ca64-8eae-45ba-bdcf-5b9c46dc7fd0'
    }
};

export default cero;



// WEBPACK FOOTER //
// ./src/data/product/cero.js